module.exports = __webpack_public_path__ + "static/leads_bottom_image.e4a19df5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/leads_bottom_image.jpg
// module id = 3145
// module chunks = 146304318568534